import React from "react";
import { Camera, MessageCircle, ShieldCheck, Sparkles } from "lucide-react";

export default function HowItWorks() {
  return (
    <div className="pbp-section py-12 md:py-16 max-w-3xl">
      <div className="text-xs uppercase tracking-[0.18em] text-[#86868b] font-semibold">Guide</div>
      <h1 className="mt-2 text-4xl font-semibold tracking-tighter">How PartByPart works</h1>

      <div className="mt-10 grid gap-6">
        {[
          { i: Camera, t: "Photograph the part", d: "Snap 2+ clear photos. Our AI reads the image, identifies the model and part, and pre-fills the listing form to minimise human error." },
          { i: Sparkles, t: "Review AI suggestions", d: "Edit any field before publishing. Model numbers like A2338 are validated against Apple's known formats." },
          { i: MessageCircle, t: "Chat directly", d: "Buyers chat with sellers in real time. Each conversation opens with a safety reminder and an option to report misconduct." },
          { i: ShieldCheck, t: "Meet safely", d: "We never handle payments. You meet in person or arrange shipping yourselves — always inspect before paying." },
        ].map(({ i: Icon, t, d }, idx) => (
          <div key={t} className="pbp-card p-6 flex gap-4">
            <div className="w-11 h-11 rounded-xl bg-[#0071e3]/10 grid place-items-center text-[#0071e3]"><Icon className="w-5 h-5" strokeWidth={1.6} /></div>
            <div>
              <div className="text-xs uppercase tracking-wider text-[#86868b] font-semibold">Step {idx + 1}</div>
              <div className="text-lg font-semibold tracking-tight mt-0.5">{t}</div>
              <p className="mt-1 text-[#1d1d1f]/80">{d}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
